export const anyRowSelected = (data) => {
  for (let i = 0; i < data.length; i++) {
    const object = data[i];
    if (object.selected) return true;
  }

  return false;
};

export const allRowsSelected = (data) => {
  for (let i = 0; i < data.length; i++) {
    const object = data[i];
    if (!object.selected) return false;
  }

  return true;
};

/**
 * Determines if an object is a placeholder object for the table.
 *
 * @param {object} object
 * @returns {boolean} boolean
 */
export const isPlaceholderObject = (object) => {
  if (!object) return true;

  const keys = Object.keys(object);

  for (let i = 0; i < keys.length; i++) {
    if (object[keys[i]] !== '') return false;
  }

  return true;
};
